
function BSPSelectBox($container) {
    this.$container = $container;
    this.$btnSelect;
    this.$listContainer;
    this.$searchContainer;
    this.$listItems;

    this.init();
}

BSPSelectBox.prototype.init = function() {
    var _ = this;

    _.$btnSelect = _.$container.find('.btn-custom-select');
    _.$listContainer = _.$container.find('.list-container');
    _.$searchContainer = _.$container.find('.search-word');
    _.$textField = _.$searchContainer.find('input[type=text]');
    _.$listItems = _.$listContainer.find('button');

    _.initEvent();
}

BSPSelectBox.prototype.initEvent = function() {
    var _ = this;

    _.$btnSelect.off('click').on('click', function(e) {
        $(this).toggleClass("is-selected");

        _.$listContainer.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function() {
            _.$textField.focus();
        });

    });

    _.$btnSelect.on('keydown', function(e) {
        switch(e.keyCode) {
            case 40: {
                _.$listContainer.find('button:visible').eq(0).focus();
                break;
            }
        }
    })

    _.$listItems.off('click').on('click', function(e) {
        _.select($(this));
    });

    _.$listItems.on('keydown', function(e) {
        switch(e.keyCode) {
            case 38: {
                var $items = _.$listContainer.find('button:visible');
                var index = $items.index(this);
                if( index == 0 ) {
                    _.$textField.focus();
                } else {
                    $items.eq(index-1).focus();
                }
                break;
            }

            case 40: {
                var $items = _.$listContainer.find('button:visible');
                var index = $items.index(this);
                $items.eq(index+1).focus();
                break;
            }
        }
    });

    _.$textField.on('keyup', function(e) {
        var keyword = e.target.value.toString();
        var $btns = _.$listContainer.find('.list-custom-select button');
        if( keyword.length <= 0 ) {
            $btns.closest('li').removeClass('not-match');
        }
        $.each($btns, function(index, element) {
            var orgText = $(element).html();
            orgText = orgText.replace('<mark>', '').replace('</mark>', '');
            var startIdx = orgText.toUpperCase().indexOf(keyword.toUpperCase());
            var length = keyword.length;
            var markWord = orgText.substr(startIdx, length);
            if(orgText.toUpperCase().indexOf(keyword.toUpperCase()) !== -1){
                var newText = orgText.replace(markWord, '<mark>'+markWord+'</mark>');
                $(element).html(newText);
                $(element).closest('li').removeClass('not-match');
            } else {
                $(element).closest('li').addClass('not-match');
            }
        });
        switch(e.keyCode) {
            case 40: {
                _.$listContainer.find('button:visible').eq(0).focus();
                break;
            }
        };
    });
}

BSPSelectBox.prototype.hide = function() {
    var _ = this;

    _.$btnSelect.removeClass("is-selected")
}

BSPSelectBox.prototype.select = function($item) {
    var _ = this;

    _.$listItems.closest('li').removeClass('is-selected');
    $item.closest('li').addClass('is-selected');

    // _.$btnSelect.html($item.html());
    _.hide();
}

BSPSelectBox.prototype.resetSearchWord = function() {
    var _ = this;

    _.$textField.val('').trigger('keyup');
}
/*
exports.GlobalMenu = (function ($) {
    var scope,
        $container,
        selectService,
        selectCompany,
        $user,
        $btnNotification,
        $allMenus,
        init = function() {
            $container = $('.global-menu');

            $user = $container.find('.user');
            $btnNotification = $container.find('.btn-notification');
            $allMenus = $container.find('.btn-all-menus');

            initLayout();
            initEvent();
        },
        setCompany = function() {
            selectCompany = new BSPSelectBox($('#select-company'));

            $(document).click(function (event) {
                if( !$(event.target).closest("#select-company").length ) {
                    selectCompany.resetSearchWord();
                    selectCompany.hide();
                }
            });
        },
        setService = function() {
            selectService = new BSPSelectBox($('#select-service'));

            $(document).click(function (event) {
                if( !$(event.target).closest("#select-service").length ) {
                    selectService.hide();
                }
            });
        },
        setMenu = function() {

        }

    function initLayout() {
    }

    function initEvent() {
        $user.on('click', function() {
            $(this).toggleAttr('data-state', 'open');
        });

        $btnNotification.on('click', function(e) {
            $(this).closest('.notification').toggleAttr('data-state', 'open');
        });

        $allMenus.on('click', function() {
            $(this).closest('.all-menus').toggleAttr('data-state', 'open');
        });

        $(document).click(function (event) {
            if( !$(event.target).closest(".user").length ) {
                $user.removeAttr('data-state');
            }
            if( !$(event.target).closest(".all-menus").length ) {
                $allMenus.closest('.all-menus').removeAttr('data-state');
            }
            if( !$(event.target).closest(".notification").length ) {
                $btnNotification.closest('.notification').removeAttr('data-state');
            }
        });
    }

    return {
        init: function() {
            init();
        },
        setService: function() {
            setService();
        },
        setCompany: function() {
            setCompany();
        },
        setMenu: function() {
            setMenu();
        }
    };
}(jQuery));
*/

/*
//혹시 몰라 남겨놓음 개발 완료되면 삭제
exports.ConsoleGNB = (function ($) {
    var scope,
        $container,
        $btnNotification,
        $btnUser,
        $btnSelectedService,
        $listNotice,
        $containerService,
        $listService,
        $layerMenusContainer,
        heightService,
        selectCompany,
        init = function() {
            $container = $('.console-gnb');
            $layerMenusContainer = $container.find('.service-container .service-container-inner');
            $btnNotification = $container.find('.btn[data-icon=notice]');
            $btnUser = $container.find('.btn.user');
            $listNotice = $container.find('.list-gnb-notice');

            $btnSelectedService = $container.find('.btn-selected-service');
            $containerService = $container.find('.menus .list-service');
            $listService = $containerService.find('> li');

            heightService = $containerService.outerHeight();
            // console.log("heightService : " + heightService);

            selectCompany = new ONCompanyBox($('#select-company'));

            initLayout();
            initEvent();
        },
        setServiceList = function() {
            $container = $('.console-gnb');
            $containerService = $container.find('.menus .list-service');
            $listService = $containerService.find('> li');

            $listService.on('mouseenter', function(e) {
                updateSubmenus($(this));
            }).on('mouseleave', function(e) {
            });
        }

    function initLayout() {
        $('.layout-wrap').css({
            paddingTop: $container.outerHeight() + "px"
        });

        $listService.each(function(e) {
            var $item = $(this);
            if( $item.hasClass('selected') ) {
                updateSubmenus($(this));
            }
        });
    }

    function initEvent() {
        $btnNotification.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
        });

        $btnUser.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
        });

        $btnSelectedService.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
            _updateService();
        });

        $listService.on('mouseenter', function(e) {
            updateSubmenus($(this));
        }).on('mouseleave', function(e) {
        });

        $container.find('.ticker-wrapper').easyTicker({
            direction: 'up',
            interval: 5000,
            visible: 1,
            mousePause: 1,
        });


        $(document).click(function (e) {
            if( !$(e.target).closest("#select-company").length ) {
                selectCompany.resetSearchWord();
                selectCompany.hide();
            }

            if( !$(e.target).closest("[data-icon=notice]").length ) {
                $btnNotification.removeAttr('data-state');
            }

            if( !$(e.target).closest(".user").length ) {
                $btnUser.removeAttr('data-state');
            }

            if( !$(e.target).closest(".btn-selected-service").length ) {
                $btnSelectedService.removeAttr('data-state');
                updateSubmenus( $listService.eq(0) );
            }
        });
    }

    function _updateHeight($service) {
        var $submenus = $service.find('ul');

        if( $submenus.length > 0 ) {
            var rightHeight = $submenus.outerHeight();
            var leftHeight = 0
            $listService.each(function(){
                leftHeight += parseInt($(this).outerHeight()) || 0;
            });

            $containerService.css({
                height: (rightHeight > leftHeight ? rightHeight : leftHeight) + "px"
            });
        }
    }

    function updateSubmenus($service) {
        $container = $('.console-gnb');
        $containerService = $container.find('.menus .list-service');
        $listService = $containerService.find('> li');

        $listService.removeClass('selected');
        $service.addClass('selected');

        _updateHeight($service);
    }

    function _updateService() {
        $container = $('.console-gnb');
        $containerService = $container.find('.menus .list-service');
        $listService = $containerService.find('> li');

        var $service = $listService.each(function() {
            var $this = $(this);
            if( $this.hasClass('selected') ) {
                $this.removeClass('selected');
                return $this;
            }
        });

        $('li.opsnow').addClass('selected');
        $service = $('li.opsnow');
        _updateHeight($service);
    }

    return {
        init: function() {
            init();
        },
        setServiceList: function() {
            setServiceList();
        }
    };
}(jQuery));
*/


exports.ConsoleGNB = (function ($) {
	var scope,
		$container,
		$btnNotification,
		$btnUser,
		$btnSelectedService,
		$listNotice,
		$containerService,
		$listService,
		$layerMenusContainer,
		heightService,
		selectCompany,

		$submenusContainer,
		$listSubmneus,
		containerWidth,
		indexSubmenu = 0,
		pages = [0],
        $menuWrapper,
        $menuScroll,
        $settingArea,
        $menuSelect,
        $closeBtn,
        $serviceFold,
        $serviceFoldList,
        $btnSupport,
        $notifications,
        $btnPrev,
        $btnNext,
		init = function() {
			$container = $('.console-gnb');

            $menuWrapper = $('.menu-wrapper');
			$menuScroll = $menuWrapper.find('.menu-scroll');
			$settingArea = $menuWrapper.find('.setting-btn-area');
			$menuSelect = $menuScroll.find('>ul>li').not('.no-service-list');
			$closeBtn = $menuWrapper.find('[data-icon=closelist]');
			$serviceFold = $menuWrapper.find('.service-fold');
			$serviceFoldList = $serviceFold.find('[data-service] li .arrow');


			$layerMenusContainer = $container.find('.service-container .service-container-inner');
			$btnNotification = $container.find('.btn[data-icon=notice]');
            $btnSupport = $container.find('.btn[data-icon=support]');
            $notifications = $container.find('.list-notification');
			$btnUser = $container.find('.btn.user');
			$listNotice = $container.find('.list-gnb-notice');

			$btnSelectedService = $container.find('.btn-selected-service');
			$containerService = $container.find('.menus .list-service');
			$listService = $containerService.find('> li');

			heightService = $containerService.outerHeight();
			selectCompany = new ONCompanyBox($('#select-company'));

			$submenusContainer = $container.find('.submenus-container');
			$listSubmneus = $submenusContainer.find('.list-submenus > li');
			$btnPrev = $submenusContainer.find('.btn.prev');
			$btnNext = $submenusContainer.find('.btn.next');

			initLayout();
			initEvent();
		},
    setServiceList = function() {
        $container = $('.console-gnb');
        $containerService = $container.find('.menus .list-service');
        $listService = $containerService.find('> li');

        $listService.on('mouseenter', function(e) {
            updateSubmenus($(this));
        }).on('mouseleave', function(e) {
        });




    },
    setCompany = function() {
        $(document).click(function (event) {
            if( !$(event.target).closest("#select-company").length ) {
                selectCompany.resetSearchWord();
                selectCompany.hide();
            }
        });
    }

	function initLayout() {
    if($menuWrapper.is(':visible')){
			$('.layout-wrap').css({
				paddingTop: $container.outerHeight() + "px",
				paddingLeft : $menuWrapper.outerWidth() + "px"
			});
		}else{
			$('.layout-wrap').css({
				paddingTop: $container.outerHeight() + "px"
			});
		}

    $listService.each(function(e) {
      var $item = $(this);
      if( $item.hasClass('highlight') ) {
        updateSubmenus($(this));
      }
    });
	}

	function initEvent() {
		$btnNotification.on('click', function(e) {
			$(this).toggleAttr('data-state', 'open');
		});

		$btnUser.on('click', function(e) {
			$(this).toggleAttr('data-state', 'open');
		});

		$btnSelectedService.on('click', function(e) {
			$(this).toggleAttr('data-state', 'open');
			_updateService();
		});

    if($btnSupport.length < 1){
      $('.list-notification').addClass('list-notification-cn');
    }



		$container.find('.ticker-wrapper').easyTicker({
			direction: 'up',
			interval: 5000,
			visible: 1,
			mousePause: 1,
		});

    _updateNavSubmenus();
		_scrollFixed();
		_gnbInteraction();
		_gnbScrollBottom();
		_menuScrollTop();
    _tooltip();

		$(window).scroll(_scrollFixed);
		$(window).scroll(_gnbScrollBottom);
		$(window).resize(_updateNavSubmenus);
		$(window).resize(_gnbInteraction);

		$menuScroll.scroll(_menuScrollTop)

		$(document).click(function (e) {
			$listService.each(function(e) {
				var $item = $(this);
				if( $item.hasClass('selected') ) {
					updateSubmenus($(this));
				}
			});

			if( !$(e.target).closest("#select-company").length ) {
				selectCompany.resetSearchWord();
				selectCompany.hide();
			}

			// if( !$(e.target).closest(".menu-wrapper").length ) {
			// 	$menuWrapper.attr('data-open','');
			// 	$menuSelect.removeClass('selected');
			// 	_checkedData(null);
			// }

			if( !$(e.target).closest("[data-icon=notice]").length ) {
				$btnNotification.removeAttr('data-state');
			}

			if( !$(e.target).closest(".user").length ) {
				$btnUser.removeAttr('data-state');
			}

			if( !$(e.target).closest(".btn-selected-service").length ) {
				$btnSelectedService.removeAttr('data-state');
			}
		});
	}

  function _tooltip() {

		var TOOLTIPS = "gnb-tooltip"; // 툴팁 class
		var CLS_ON = "tooltip_ON";
		var FOLLOW = true;
    var DATA = "_tooltip_text_save"; //툴팁 텍스트 넣어두는곳
		var OFFSET_X = 0;
		var OFFSET_Y = 30;


    var showAt = function (e) {
        var ntop = e.pageY + OFFSET_Y, nleft = e.pageX + OFFSET_X;
        $("." + TOOLTIPS).html( "<p> "+ $(e.target).data(DATA) +"</p>").css({
            position: "absolute", top: ntop, left: nleft
        }).show();
    };
    $(document).on("mouseenter", ".menu-scroll *[title]:not([title=''])", function (e) {
				if (!$(this).attr('title')) return;
        $(this).data(DATA, $(this).attr("title"));
        $(this).removeAttr("title").attr('data-tooltip',CLS_ON);
        $("<div class='" + TOOLTIPS + "' />").appendTo("body");
        showAt(e);
    });

    $(document).on("mouseleave", "[data-tooltip="+ CLS_ON +"]" , function (e) {
        $(this).attr("title", $(this).data(DATA)).removeAttr('data-tooltip');
        $("." + TOOLTIPS).remove();
    });
    if (FOLLOW) { $(document).on("mousemove", "[data-tooltip="+ CLS_ON +"]", showAt); }


	}

	function _moveNav() {
		var left = 0;
		$.map($listSubmneus, function(value, i) {
			//console.log("[" + i + "]pageWidth : " + $(value).outerWidth());
			if( i < pages[indexSubmenu] ) {
				left += $(value).outerWidth();
				//console.log("[ " + pages[indexSubmenu] + "] left: " + left);
			}
		});

		if( left != 0 ) {
			left -= 20;
		}
		$submenusContainer.find('.list-submenus').animate({
			left: -left + "px"
		}, 200, function() {

		});

		_updateNavButtons();
	}

	function _updateNavButtons() {
		if( indexSubmenu < pages.length - 1 ) {
			$btnNext.show();
		} else {
			$btnNext.hide();
		}

		if( indexSubmenu != 0 ) {
			$btnPrev.show();
		} else {
			$btnPrev.hide();
		}
	}

	function _updateNavSubmenus() {
		containerWidth = $submenusContainer.outerWidth() - 30;

		indexSubmenu = 0;
		pages = [0];
		var totalWidth = 0;
		var pageWidth = 0;

		$.map($listSubmneus, function(value, index) {
			totalWidth += $(value).outerWidth();
			pageWidth += $(value).outerWidth();
			//console.log("[" + index + "]pageWidth : " + pageWidth);
			if( pageWidth > containerWidth ) {
				pages.push(index);
				pageWidth = 0;
			}
		});

		// prev, next button
		_updateNavButtons();
		_moveNav();

		$btnNext.off('click').on('click', function(e) {
			indexSubmenu++;
			if( indexSubmenu >= pages.length ) {
				indexSubmenu = pages.length - 1;
				return false;
			}

			_moveNav();
		});

		$btnPrev.off('click').on('click', function(e) {
			indexSubmenu--;
			if( indexSubmenu < 0 ) {
				indexSubmenu = 0;
				return false;
			}
			_moveNav();
		});
		// console.log("containerWidth : " + containerWidth);
		// console.log("totalWidth : " + totalWidth);
		// console.log("pages : " + pages);
	}

	function _scrollFixed() {
		$container.css("left", -$(this).scrollLeft());
	}

  // type에 따라 덮는 ui 콘텐츠를 미는 ui를 선택할수있음
	// true : 덮는 false : 미는
	function _checkedData(type){
		if(!type){
			$('.layout-wrap').css({
				paddingLeft : $menuWrapper.outerWidth() + "px"
			});
		}else{
			$('.layout-wrap').css({
				paddingLeft : ($menuWrapper.outerWidth() + $serviceFold.outerWidth()) + "px"
			});
		}
	}

	// document resize이벤트에 따라 gnb 덮는 or 미는 UI 함수
	function _gnbInteraction(){
		var resizeWidth = $(document).width();
		var $body = window.document.body;
		var clientHeight = $body.clientHeight;
		var scrollHeight  = $body.scrollHeight;


		var layoutContents = $('.layout-contents').outerWidth();
		var menuListHeight = $menuScroll.find('li').outerHeight() * $menuScroll.find('li').length;
		var settingHeight = $settingArea.outerHeight();
		var headerHeight = $('.logo-n-companies').outerHeight();

		var lowHeightShow = clientHeight - settingHeight - headerHeight;


		$menuScroll.css({'height' : 'calc(100% - '+ settingHeight +'px)'});


		var toggles = true;

		// gnb전체값 292에서 full hd 1920을 뺀 1628부터 292를 더한 2212까지는 밀리는 형식

		// if(layoutContents < 1440){
		// 	if(resizeWidth > 1628 && resizeWidth < 2212){
		// 		toggles = true;
		// 	} else{
		// 		toggles = null;
		// 	}
		// }else{
		// 	if(resizeWidth < 1628){
		// 		toggles = null;
		// 	} else{
		// 		toggles = true;
		// 	}
		// }


		if( menuListHeight > lowHeightShow ){
			$menuWrapper.addClass('low-height');
		}else{
			$menuWrapper.removeClass('low-height');
		}



		_gnbAction(toggles)

	}

	// gnb메뉴 스크롤할때 아래 스크롤할수있다는 UI삭제 함수
	function _menuScrollTop(){
		var topValue = $menuScroll.scrollTop();
		topValue === 0 ? $menuWrapper.addClass('scrolling') : $menuWrapper.removeClass('scrolling');
	}


	function _gnbScrollBottom(){
		var $body = window.document.body;
		var scrollHeight  = $body.scrollHeight;
		var clientHeight = $body.clientHeight;
		var scrolls = this.pageYOffset;

		if((scrollHeight - scrolls) === clientHeight || (scrollHeight - scrolls) < clientHeight){
			$menuWrapper.addClass('height-bottom');
		}else{
			$menuWrapper.removeClass('height-bottom')
		}
	}



	// GNB인터렉션을 모아놓은 함수

	function _gnbAction(push){

		$.map($menuSelect,function(value){
			$(value).on('click',function(){
				//var serviceName = $(this).find('>button').attr('class');
				var foldService = $(this).closest('.menu-wrapper').find('.service-fold');
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
				$(this).closest('.menu-wrapper').attr('data-open','open');

				_checkedData(push);

				// foldService.find('>div').attr('hidden',true);
				// foldService.find('.'+serviceName+'').removeAttr('hidden');
			})
		});

        $menuWrapper.on('mouseleave',function(){
            $menuWrapper.attr('data-open','');
            $menuSelect.removeClass('selected');

            $menuScroll.find('button[class=osn]').parent('li').addClass('selected');
            $menuScroll.find('button[class!=osn]').parent('li').removeClass('selected');
            //_checkedData(null);
        });

		$closeBtn.on('click',function(){
            $menuWrapper.attr('data-open','');
            $menuSelect.removeClass('selected');
            //_checkedData(null);
		});

		$.map($serviceFoldList,function(value){
			var toggled = false;
			$(value).on('click',function(e){
				toggled = !toggled;

				if($(this).closest('li').attr('data-depth')){
					$(this).closest('li').attr('data-depth',toggled ? 'on' : 'off');
				}

				e.stopImmediatePropagation();
			});

		});
	}

	function _updateHeight($service) {
		var $submenus = $service.find('ul');

		if( $submenus.length > 0 ) {
			var rightHeight = $submenus.outerHeight(true);
			var leftHeight = 0
			$listService.each(function(){
				leftHeight += parseInt($(this).outerHeight(true)) || 0;
			});

			$containerService.css({
				height: (rightHeight > leftHeight ? rightHeight : leftHeight) + "px"
			});
		}
	}

	function updateSubmenus($service) {
		$service.addClass('highlight').siblings().removeClass('highlight');

		_updateHeight($service);
	}

	function _updateService() {
		var $service = $listService.each(function() {
			var $this = $(this);
			if( $this.hasClass('selected')) {
				return $this;
			}
		})

		_updateHeight($service);
	}

	return {
		init: function() {
			init();
		},
    setServiceList: function() {
        setServiceList();
    },
    setCompany: function() {

        setCompany();
    }
	};
}(jQuery));



//////////////////
// WEBPACK FOOTER
// ./src/app/components/GNB/header/header.js
// module id = ./src/app/components/GNB/header/header.js
// module chunks = main